/* eslint-disable import/no-anonymous-default-export */

export default {
  certificateImg: require("../../Assets/Images/Audition-images/CertificatePhoto.png"),
  dash: require("../../Assets/Images/Audition-images/Group1176.png"),
  bar: require("../../Assets/Images/Audition-images/Group1137.png"),
  star: require("../../Assets/Images/Audition-images/Group1111.png"),
  people: require("../../Assets/Images/Audition-images/Group.png"),
  delPS: require("../../Assets/Images/Vector.png"),
  Under: require("../../Assets/Images/Uder.png"),
  tennisImg: require("../../Assets/Images/tennis.jpeg"),
  cricketImg: require("../../Assets/Images/cricket.jpg"),
  golfImg: require("../../Assets/Images/golf.jpg"),
  pubg: require("../../Assets/Images/pubg.jpeg"),
  archaryImg: require("../../Assets/Images/archery.jpg"),
  meetUpEventImg: require("../../Assets/Images/MeetUpEvent.png"),
  ModalImg: require("../../Assets/Images/starProfile/modalImg.png"),
  Market1: require("../../Assets/Images/Carosuel/Market/1.jpg"),
  Market2: require("../../Assets/Images/Carosuel/Market/2.jpg"),
  Market3: require("../../Assets/Images/Carosuel/Market/3.jpg"),
  avaterImage: require("../../Assets/Images/CreateAccount-page/Avater.png"),
};
